import { WORKING_HOURS_END, WORKING_HOURS_START } from "@wheels-crm/shared-types";

/**
 * Clamps a "HH:MM" time string into the 09:00–19:00 working-hours window (AGENTS.md §6.5).
 * This mirrors the Postgres trigger in supabase/migrations/0003_triggers.sql — the DB is the
 * real safety net, this just keeps the UI honest before the value ever leaves the browser.
 */
export function clampToWorkingHours(time: string): string {
  if (!time) return WORKING_HOURS_START;
  if (time < WORKING_HOURS_START) return WORKING_HOURS_START;
  if (time > WORKING_HOURS_END) return WORKING_HOURS_END;
  return time;
}

/** Combines a "YYYY-MM-DD" date and "HH:MM" time (already clamped) into an ISO instant. */
export function toReminderDueAt(date: string, time: string): string {
  const clamped = clampToWorkingHours(time);
  return new Date(`${date}T${clamped}:00`).toISOString();
}
